export default {
  FETCH_NOTICE_BOARD_DATA: "FETCH_NOTICE_BOARD_DATA",
  FETCH_NOTICE_BOARD_DATA_SUCCESS: "FETCH_NOTICE_BOARD_DATA_SUCCESS",
  FETCH_NOTICE_BOARD_DATA_ERROR: "FETCH_NOTICE_BOARD_DATA_ERROR",
};
